var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container translated-text" }, [
    _c("div", { staticClass: "row description d-flex align-items-center" }, [
      _c("div", {
        staticClass:
          "col sc-message--text-content translated-text-content d-flex align-items-center",
        staticStyle: { "max-width": "80%", padding: "0px" },
        domProps: { innerHTML: _vm._s(_vm.data.text) },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "col sc-message--text-content translated-text-content d-flex align-items-center",
          staticStyle: {
            "max-width": "5%",
            padding: "0px",
            "justify-content": "end",
          },
        },
        [
          _c(
            "p",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: {
                    followCursor: true,
                    placement: "top-center",
                    theme: _vm.isDarkMode ? "light-border" : "google",
                  },
                  expression:
                    "{\n                followCursor: true,\n                placement: 'top-center',\n                theme: isDarkMode ? 'light-border' : 'google',\n            }",
                },
              ],
              staticClass: "m-0",
              staticStyle: { color: "#1890ff", "font-size": "10px" },
              attrs: {
                content: _vm.$t("message.translatedTextDescription", {
                  from: _vm.getLabel(_vm.data.from),
                  to: _vm.getLabel(_vm.data.to),
                }),
              },
            },
            [_c("a-icon", { attrs: { type: "info-circle" } })],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }